import { useContext } from 'react';
import { TaskCollapsedContext } from '../components/contexts/TaskCollapsedContext';

export const useTaskCollapsed = () => {
  const { collapsed, handleCollapsed } = useContext(TaskCollapsedContext);
  return { collapsed, handleCollapsed };
};
